import { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Avatar,
} from "@mui/material";
import { Menu as MenuIcon, Logout } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import LogoutModal from "../Models/LogoutModel";
import { useDispatch, useSelector } from "react-redux";
import { GetAdminProfile } from "../Redux/Actions/AuthAction";
import logo from "../assets/images/logo.png"
export default function Navbar({ onMenuClick }) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openLogout, setOpenlogout] = useState(false);
  const { admin } = useSelector((state) => state.Auth)
  const [data, setData] = useState(null);

  useEffect(() => {
    const FetchAdmin = async () => {
      const res = await dispatch(GetAdminProfile());
      if (res) {
        setData(res?.data);
      } else {
        console.error("Failed to fetch users data");
      }
    };
    FetchAdmin();
  }, [dispatch]);


  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorEl(null);
  };



  const handlelogout = () => {
    setOpenlogout(true);
  }

  return (
    <>
      <AppBar position="fixed" sx={{ zIndex: 1201, backgroundColor: "white" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="black"
            onClick={onMenuClick}
            sx={{ display: { sm: "none" }, fontWeight: 700 }}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            variant="h6"
            sx={{ flexGrow: 1, textAlign: { xs: "center", sm: "left" }, }}
          >

            <img src={logo} alt="Logo" height={20} width={180} />
          </Typography>

          <div className="flex items-center">
            <Typography className="hidden md:block" sx={{ color: "black", fontWeight: 500 }}>{data?.first_name}{" "}{data?.last_name}</Typography>
            <IconButton color="inherit" onClick={handleProfileClick}>
              <Avatar
                src={""}
                sx={{ height: 40, width: 40 }}
              />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>

      <Menu
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleProfileClose}
        sx={{
          "& .MuiPaper-root": { borderRadius: "8px", minWidth: 110 },
        }}
      >

        <MenuItem onClick={() => {
          handlelogout();
          handleProfileClose();
        }}
          sx={{ px: 2 }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>

      <LogoutModal
        openLogout={openLogout}
        setOpenlogout={setOpenlogout}
      />
    </>
  );
}
